const spriteCache = new Map(); // name → рабочий URL

const SPRITE_URLS = (safe, safeName) => [
  `https://play.pokemonshowdown.com/sprites/ani/${safe}.gif`,
  `https://play.pokemonshowdown.com/sprites/gen5/${safe}.png`,
  `https://play.pokemonshowdown.com/sprites/dex/${safe}.png`,
  `/image_pokemons/${safeName}.png`,
  `/image_pokemons/${safeName}.PNG`,
  `https://play.pokemonshowdown.com/sprites/substitutes/gen5/substitute.png`,
];

const normalize = (name) => ({
  safe:     (name || '').toLowerCase().replace(/[^a-z0-9-]/g, '').replace(/\s+/g, '-'),
  safeName: (name || '').toLowerCase().replace(/\s+/g, '-').replace('(', '').replace(')', ''),
});

/**
 * Возвращает src для img — сразу из кэша если уже нашли,
 * иначе первый кандидат (gif), а onError доберёт остальные
 */
export const getSpriteUrl = (name) => {
  if (spriteCache.has(name)) return spriteCache.get(name);
  const { safe } = normalize(name);
  return `https://play.pokemonshowdown.com/sprites/ani/${safe}.gif`;
};

/**
 * onError handler — пробует следующий URL и сохраняет найденный в кэш
 */
export const mkFb = (name) => {
  // Если уже знаем рабочий URL — не нужен fallback вообще
  if (spriteCache.has(name)) return undefined;

  const { safe, safeName } = normalize(name);
  const urls = SPRITE_URLS(safe, safeName);
  // Начинаем с индекса 1 — gif (индекс 0) уже пробовали как src
  let idx = 1;

  return (e) => {
    if (idx >= urls.length) return;
    const nextUrl = urls[idx++];
    e.target.src = nextUrl;

    // Если это не последний fallback (substitute) — слушаем успех
    if (idx < urls.length) {
      e.target.onload = () => {
        spriteCache.set(name, e.target.src);
        e.target.onload = null;
      };
    }
  };
};

/**
 * Предзагрузка спрайтов для списка покемонов (вызвать один раз при старте)
 */
export const preloadSprites = (names) => {
  names.forEach(name => {
    if (spriteCache.has(name)) return;

    const { safe, safeName } = normalize(name);
    const urls = SPRITE_URLS(safe, safeName);
    let idx = 0;

    const tryNext = () => {
      if (idx >= urls.length) return;
      const img = new Image();
      img.src = urls[idx++];
      img.onload = () => spriteCache.set(name, img.src);
      img.onerror = tryNext;
    };

    tryNext();
  });
};